import { render, staticRenderFns } from "./PermitForm5.vue?vue&type=template&id=3a275ddc"
import script from "./PermitForm5.vue?vue&type=script&lang=js"
export * from "./PermitForm5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports